import { useFormContext } from 'react-hook-form';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export function EditNotificationRuleMessageTemplateForm() {
  const form = useFormContext<NotificationRule>();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold">Preview</h2>
      </div>
      <div className="bg-muted rounded-md border p-3">
        <p className="min-h-5 text-sm">{form.getValues('notificationPreviewTemplate')}</p>
      </div>
    </div>
  );
}
